import BaseModel from '../base/BaseModel.model';
import User from '../security/user.model';
import Pregunta from './pregunta.model';
import { AnswerType } from '@/enums/AsnwerType';

export default class AnswerUI extends BaseModel {

    public evaluatorsUI: Array<User> = [];
    public answerUI: string = '';
    public answerTypeUI: AnswerType = null;
    public questionId: number = 0;

    constructor(){
        super();
        this.init();
    }

    init(){}
}